<template lang="pug">
  el-container#app
    router-view
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style module>
  html {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  #app {
    background-color: #fff;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: -17px;
    overflow-y: scroll;
  }
</style>
